import actionTypes from '../constants/action-types';

const hideAnchors = () => ({
  type: actionTypes.HIDE_ANCHOR_HIGHLIGHTERS,
});

export default hideAnchors;
